import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import type { LoadFlowMergedScenariosResult } from '../../../..';
import { Amperes } from '../../../../domain/ElectricCurrent';
import type { ForStoringAttentionStatus } from '../../../../evaluation/AttentionStatusRepository';
import { AcLineSegmentEvaluation } from '../../../../evaluation/loadFlow/gridElements/acLineSegment/acLineSegmentEvaluation';
import type { ForAcLineSegmentEvaluation } from '../../../../evaluation/loadFlow/gridElements/acLineSegment/forAcLineSegmentEvaluation';
import type { FunctionalGrid } from '../../../../grid/FunctionalGrid';
import {
  findGridElementLabel,
  findGridElementTitle
} from '../../findGridElementLabel';
import type { AcLineLoadFlowDetails } from '../gridElementLoadFlowDetails.types';
import { Features } from '../../../../createGridElementCalculationSetExecutionDetails';

export function createAcLinesLoadFlowDetails(
  features: Features,
  evaluationEngine: ForAcLineSegmentEvaluation,
  results: LoadFlowMergedScenariosResult[],
  functionalGrid: FunctionalGrid,
  attentionStatusRepository: ForStoringAttentionStatus
): AcLineLoadFlowDetails[] {
  const evaluatedResults = AcLineSegmentEvaluation.fromResults(
    results,
    attentionStatusRepository
  ).evaluateEachLine(evaluationEngine);
  return evaluatedResults.map(evaluatedAcLine => ({
    ...evaluatedAcLine,
    label: findGridElementLabel(features, evaluatedAcLine.id),
    title: findGridElementTitle(features, evaluatedAcLine.id),
    inputs: {
      ratedCurrent: Amperes.fromAmperes(
        findCurrent(evaluatedAcLine.id, functionalGrid)
      )
    }
  }));
}

function findCurrent(id: string, functionalGrid: FunctionalGrid): number {
  return (
    functionalGrid.acLineSegments.find(x => x.objectId === id)
      ?.maximumCurrent ?? 0
  );
}
